import { ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { EventsService } from '../../../services/events.service';
import { FixturesService } from '../../../services/fixtures.service';
import { RacesService } from '../../../services/races.service';
import { EntriesService } from '../../../services/entries.service';
var FixtureRacecardsComponent = /** @class */ (function () {
    function FixtureRacecardsComponent(notification, route, eventsService, fixturesService, racesService, entriesService, changeDetector) {
        var _this = this;
        this.notification = notification;
        this.route = route;
        this.eventsService = eventsService;
        this.fixturesService = fixturesService;
        this.racesService = racesService;
        this.entriesService = entriesService;
        this.changeDetector = changeDetector;
        this.prepareReady = false;
        this.layoutReady = false;
        this.prepareLog = [];
        this.prepareProgress = 0;
        this.elapsedLabel = '0s';
        this.prepareLogTailSize = 10;
        this.prepareStartedAt = null;
        this.elapsedTimer = null;
        this.getFixtureInfo = function (fixtureYear, fixtureId) {
            _this.setPrepareStatus('Loading fixture information…', 8);
            _this.fixturesService.getFixtureInfo({ fixtureYear: fixtureYear, fixtureId: fixtureId }).subscribe(function (res) {
                _this.fixture = res;
                _this.fixture.fixtureYear = _this.fixture.year;
                _this.eventsService.changeFixtureData(_this.fixture);
                _this.setPrepareStatus("Fixture loaded: " + (_this.fixture.courseName || 'meeting') + " (" + moment(_this.fixture.fixtureDate).format('DD/MM/YYYY') + ")", 15);
                _this.getFixtureRaces(_this.fixture.fixtureYear, _this.fixture.fixtureId);
            }, function (err) {
                _this.notification.error("Could't get the Fixture information: " + _this.eventsService.getApiErrorMessage(err), 'Error!');
                _this.failPrepare();
            });
        };
        this.getFixtureRaces = function (fixtureYear, fixtureId) {
            _this.setPrepareStatus('Loading race list…', 20);
            _this.fixturesService.getFixtureRaces({ fixtureYear: fixtureYear, fixtureId: fixtureId }).subscribe(function (res) {
                _this.races = res;
                _this.setPrepareStatus("Found " + _this.races.length + " race" + (_this.races.length === 1 ? '' : 's') + " \u2014 loading runners and race details\u2026", 25);
                forkJoin(_this.getEntries(_this.races), _this.getRaceInfo(_this.races)).subscribe(function () { return console.log(_this.fixture, _this.races); }, function (err) {
                    console.log(err);
                    _this.failPrepare();
                }, function () {
                    _this.setPrepareStatus('Finalising layout…', 95);
                    setTimeout(function () {
                        _this.meta.started = false;
                        _this.meta.loading = false;
                        _this.prepareReady = true;
                        _this.stopElapsedTimer();
                        _this.setPrepareStatus("Ready to print (" + _this.elapsedLabel + ").", 100);
                        setTimeout(function () {
                            // RPC only: measure/pack/stretch. Non-RPC uses customHeightPx formula.
                            if (_this.withRPC) {
                                _this.stretchEntryHeights();
                            }
                            _this.layoutReady = true;
                            _this.changeDetector.detectChanges();
                        }, 300);
                    }, 1000);
                });
            }, function (err) {
                _this.notification.error("Could't get the Fixture Entries with Sampling Requests: " +
                    ("" + _this.eventsService.getApiErrorMessage(err)), 'Error!');
                _this.failPrepare();
            });
        };
        this.getRaceInfo = function (races) {
            return new Promise(function (resolve, reject) {
                _this.setPrepareStatus('Loading race information…', 30);
                var raceInfoRequests = races.map(function (race) { return _this.racesService.getRaceInfo(race); });
                forkJoin.apply(void 0, raceInfoRequests).subscribe(function (results) {
                    results.forEach(function (raceInfo, index) {
                        if (!raceInfo || !raceInfo['fixtureId']) {
                            console.log('Failed to load data:', races[index].raceId, races[index]);
                            _this.notification.error("Could't get race info for the " + moment(races[index].raceDateTime).format('HH:mm') + " race.", 'Error!');
                            _this.races[index].info = {};
                        }
                        else {
                            _this.races[index].info = raceInfo;
                        }
                    });
                    _this.setPrepareStatus('Race information loaded.', _this.withRPC ? 35 : 40);
                    resolve();
                }, function (errors) {
                    console.log('Failed to load data:', errors);
                    _this.notification.error("Could't get info for races.", 'Error!');
                    _this.failPrepare();
                    reject(errors);
                });
            });
        };
        this.getEntries = function (races) {
            return new Promise(function (resolve, reject) {
                _this.setPrepareStatus('Loading runners…', 32);
                var racesCompleted = 0;
                var entriesRequests = races.map(function (race) { return _this.racesService.getRaceEntries(race); });
                forkJoin.apply(void 0, entriesRequests).subscribe(function (results) {
                    results.forEach(function (entries, indexRace) {
                        if (!entries || !entries[0]) {
                            console.log('Failed to load data:', races[indexRace].raceId, races[indexRace]);
                            _this.notification.error("Could't get some details for the " + moment(races[indexRace].raceDateTime).format('HH:mm') + " race.", 'Error!');
                            _this.races[indexRace].entries = [];
                            if (_this.withRPC) {
                                racesCompleted++;
                                _this.setPrepareProgress(_this.rpcProgress(racesCompleted, races.length));
                                if (racesCompleted === races.length) {
                                    resolve();
                                }
                            }
                            else {
                                racesCompleted++;
                                if (racesCompleted === races.length) {
                                    _this.setPrepareStatus('Runners loaded.', 85);
                                    resolve();
                                }
                            }
                        }
                        else {
                            for (var i = 0; i < entries.length; i++) {
                                entries[i] = _this.processWearingCodes(entries[i]);
                                entries[i].shortDispensation = entries[i].dispensation
                                    ? entries[i].shoesDispensation.dispensation.split(' ').splice(0, 4).join(' ')
                                    : null;
                                entries[i].minHeightPx = 58;
                                entries[i].imageSize = 50;
                                entries[i].customFontSize = 1;
                                entries[i].stretchMinHeightPx = null;
                                entries[i].forcePageBreak = false;
                                if (_this.withRPC) {
                                    // Natural height; stretchEntryHeights() fills leftover page space
                                    entries[i].customHeightPx = null;
                                }
                                else if (entries.length < 20) {
                                    // Proven page-fill formula (pre measure/stretch regression):
                                    // scale row height as if the page held 20 runners.
                                    entries[i].customHeightPx = (20 / entries.length) * 58 + 5;
                                    entries[i].imageSize = (20 / entries.length) * entries[i].imageSize;
                                    entries[i].customFontSize = (20 / entries.length) * entries[i].customFontSize + 5;
                                    if (entries[i].customHeightPx > 300) {
                                        entries[i].customHeightPx = 300;
                                    }
                                    // Bigger silks for small/medium fields; large fields (13+)
                                    // stay at 52. Clamp to row so padding (8px top+bottom)
                                    // never clips into the horizontal rules.
                                    var maxSilk = entries.length <= 8 ? 90 : entries.length <= 12 ? 66 : 52;
                                    if (entries[i].imageSize > maxSilk) {
                                        entries[i].imageSize = maxSilk;
                                    }
                                    if (entries.length <= 12) {
                                        var maxFit = entries[i].customHeightPx - 16;
                                        if (entries[i].imageSize > maxFit) {
                                            entries[i].imageSize = maxFit;
                                        }
                                    }
                                    if (entries[i].customFontSize > 1.15) {
                                        entries[i].customFontSize = 1.15;
                                    }
                                }
                                else {
                                    entries[i].customHeightPx = 58;
                                }
                            }
                            _this.races[indexRace].entries = entries;
                            if (_this.withRPC) {
                                var raceTime = moment(_this.races[indexRace].raceDateTime).format('HH:mm');
                                _this.setPrepareStatus("Loading comments/enquiries for " + raceTime + " (" + entries.length + " runners)\u2026", _this.rpcProgress(racesCompleted, races.length));
                                var entryLatestRequests = entries.map(function (entry) { return _this.getLatestEntryNotes(entry.horseId, _this.races[indexRace].raceDateTime); });
                                forkJoin.apply(void 0, entryLatestRequests).subscribe(function (res) {
                                    for (var indexEntry = 0; indexEntry < _this.races[indexRace].entries.length; indexEntry++) {
                                        _this.races[indexRace].entries[indexEntry].latest = res[indexEntry] || {};
                                    }
                                }, function (err) { return reject(err); }, function () {
                                    racesCompleted++;
                                    _this.setPrepareStatus("Comments/enquiries loaded for " + racesCompleted + "/" + races.length + " races", _this.rpcProgress(racesCompleted, races.length));
                                    if (racesCompleted === races.length) {
                                        resolve();
                                    }
                                });
                            }
                            else {
                                racesCompleted++;
                                if (racesCompleted === races.length) {
                                    _this.setPrepareStatus('Runners loaded.', 85);
                                    resolve();
                                }
                            }
                        }
                    });
                }, function (errors) {
                    console.log('Failed to load data:', errors);
                    _this.notification.error("Could't get some details for racecards.", 'Error!');
                    _this.failPrepare();
                    reject(errors);
                });
            });
        };
        this.getLatestEntryNotes = function (horseId, raceDate) {
            return new Promise(function (resolve, reject) {
                forkJoin(_this.entriesService.getEntryOldComments(horseId, true, moment(raceDate).format('YYYYMMDD')), _this.entriesService.getEntryOldEnquiries(horseId, moment(raceDate).format('YYYYMMDD'))).subscribe(function (res) { return resolve({
                    comment: {
                        date: res[0]['data'][0] ? res[0]['data'][0]['dateTime'] : null,
                        courseShortName: res[0]['data'][0] ? res[0]['data'][0]['courseNameShort'] : null,
                        rpc: res[0]['data'][0] ? res[0]['data'][0]['rpcComments'] : null
                    },
                    enquiry: {
                        date: res[1]['data'][0] ? res[1]['data'][0]['updatedAt'] : null,
                        courseShortName: res[1]['data'][0] && res[1]['data'][0]['race']
                            ? res[1]['data'][0]['race']['courseShortName']
                            : null,
                        offence: res[1]['data'][0] ? res[1]['data'][0]['offence'] : null
                    }
                }); }, function (err) { return reject(err); });
            });
        };
        this.doPrint = function () {
            if (_this.withRPC) {
                _this.stretchEntryHeights();
                _this.changeDetector.detectChanges();
            }
            setTimeout(function () { return window.print(); }, 50);
        };
    }
    Object.defineProperty(FixtureRacecardsComponent.prototype, "prepareLogTail", {
        /** Last N log lines (tail-style) so the current step stays visible. */
        get: function () {
            var size = this.prepareLogTailSize;
            return this.prepareLog.length <= size
                ? this.prepareLog
                : this.prepareLog.slice(this.prepareLog.length - size);
        },
        enumerable: true,
        configurable: true
    });
    FixtureRacecardsComponent.prototype.ngOnInit = function () {
        this.withRPC = false;
        this.meta = {
            started: false,
            loading: false,
            status: 'initializing',
        };
        this.races = [];
        this.fixture = {
            fixtureId: Number(this.route.snapshot.paramMap.get('fixtureId')),
            fixtureYear: this.route.snapshot.paramMap.get('fixtureYear')
        };
        // Load course/date for the page title before Prepare is clicked
        this.loadFixtureHeader();
    };
    Object.defineProperty(FixtureRacecardsComponent.prototype, "fixtureCourseLabel", {
        get: function () {
            return (this.fixture && this.fixture.courseName) || '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FixtureRacecardsComponent.prototype, "fixtureDateLabel", {
        get: function () {
            if (!this.fixture || !this.fixture.fixtureDate) {
                return '';
            }
            var parsed = moment(this.fixture.fixtureDate);
            return parsed.isValid() ? parsed.format('DD/MM/YYYY') : '';
        },
        enumerable: true,
        configurable: true
    });
    FixtureRacecardsComponent.prototype.loadFixtureHeader = function () {
        var _this = this;
        var fixtureYear = this.fixture.fixtureYear;
        var fixtureId = this.fixture.fixtureId;
        this.fixturesService.getFixtureInfo({ fixtureYear: fixtureYear, fixtureId: fixtureId }).subscribe(function (res) {
            _this.fixture = Object.assign({}, _this.fixture, res, {
                fixtureYear: res.year || fixtureYear,
                fixtureId: res.fixtureId || fixtureId
            });
            _this.eventsService.changeFixtureData(_this.fixture);
            _this.changeDetector.detectChanges();
        }, function () {
            // Title stays generic if header load fails; Prepare can still retry
        });
    };
    FixtureRacecardsComponent.prototype.ngOnDestroy = function () {
        this.stopElapsedTimer();
    };
    FixtureRacecardsComponent.prototype.start = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            if (Object.keys(params).length) {
                _this.prepareReady = false;
                _this.layoutReady = false;
                _this.races = [];
                _this.prepareLog = [];
                _this.prepareProgress = 0;
                _this.meta.started = true;
                _this.meta.loading = true;
                _this.startElapsedTimer();
                _this.setPrepareStatus(_this.withRPC
                    ? 'Starting prepare (with RPC comments/enquiries)…'
                    : 'Starting prepare (without RPC)…', 2);
                _this.getFixtureInfo(_this.fixture.fixtureYear, _this.fixture.fixtureId);
            }
        });
    };
    FixtureRacecardsComponent.prototype.rpcProgress = function (completed, total) {
        if (!total) {
            return 90;
        }
        // RPC work sits in the bulk of the bar (40–90%)
        return Math.min(90, Math.round(40 + (completed / total) * 50));
    };
    FixtureRacecardsComponent.prototype.setPrepareProgress = function (progress) {
        if (typeof progress === 'number' && progress >= this.prepareProgress) {
            this.prepareProgress = Math.min(100, progress);
        }
    };
    FixtureRacecardsComponent.prototype.setPrepareStatus = function (message, progress) {
        this.meta.status = message;
        if (typeof progress === 'number') {
            this.setPrepareProgress(progress);
        }
        var stamp = moment().format('HH:mm:ss');
        this.prepareLog = this.prepareLog.concat("[" + stamp + "] " + message);
        this.changeDetector.detectChanges();
    };
    FixtureRacecardsComponent.prototype.startElapsedTimer = function () {
        var _this = this;
        this.stopElapsedTimer();
        this.prepareStartedAt = Date.now();
        this.elapsedLabel = '0s';
        this.elapsedTimer = setInterval(function () {
            var seconds = Math.floor((Date.now() - _this.prepareStartedAt) / 1000);
            if (seconds < 60) {
                _this.elapsedLabel = seconds + "s";
            }
            else {
                var mins = Math.floor(seconds / 60);
                var secs = seconds % 60;
                _this.elapsedLabel = mins + "m " + secs + "s";
            }
            _this.changeDetector.detectChanges();
        }, 1000);
    };
    FixtureRacecardsComponent.prototype.stopElapsedTimer = function () {
        if (this.elapsedTimer) {
            clearInterval(this.elapsedTimer);
            this.elapsedTimer = null;
        }
    };
    FixtureRacecardsComponent.prototype.failPrepare = function () {
        this.meta.started = false;
        this.meta.loading = false;
        this.prepareReady = false;
        this.stopElapsedTimer();
        this.setPrepareStatus('Prepare failed — you can try again.');
    };
    FixtureRacecardsComponent.prototype.processWearingCodes = function (entry) {
        if (entry.headGearCodeDefinition) {
            // Assuming the two arrays' elements are in the same order, which should be unless the backend code changes
            var codesArray = entry.headGearCodeDefinition.abbreviation.split(' ');
            for (var i = 0; i < entry.headGearCodeDefinition.firstTimeIndicator.length; i++) {
                entry.headGearCodeDefinition.firstTimeIndicator[i].code = codesArray[i];
            }
            entry.headgear = entry.headGearCodeDefinition.firstTimeIndicator;
        }
        return entry;
    };
    /**
     * With-RPC only: measure natural heights with compact silks, pack pages
     * (prefer keeping ~10–12 runner fields on one page), then stretch rows to
     * the non-RPC formula page budget and scale silks per-race only:
     *   targetSum = count * ((20 / count) * 58 + 5)
     *   target_i  = natural_i * (targetSum / naturalSum)
     */
    FixtureRacecardsComponent.prototype.stretchEntryHeights = function () {
        var _this = this;
        if (!this.withRPC || !this.races || !this.races.length) {
            return;
        }
        // Compact silks for measure/pack — large silks before measure were forcing
        // 10-runner races onto two pages.
        this.races.forEach(function (race) {
            (race.entries || []).forEach(function (entry) {
                entry.stretchMinHeightPx = null;
                entry.forcePageBreak = false;
                entry.imageSize = 50;
            });
        });
        this.changeDetector.detectChanges();
        var formulaPageBudget = function (count) { return count * ((20 / count) * 58 + 5); };
        // Slightly above the plain 20×58 budget so moderate RPC notes on ~10
        // runners still pack onto one page; stretch then fills leftover.
        var packBudget = 20 * 72;
        // Clear gap from row borders; allow larger silks when the field is small
        var silkPad = 8;
        this.races.forEach(function (race, raceIndex) {
            if (!race.entries || !race.entries.length) {
                return;
            }
            var raceEl = document.querySelector(".print-visible .race-sheet[data-race-index=\"" + raceIndex + "\"]");
            if (!raceEl) {
                return;
            }
            var entryEls = Array.from(raceEl.querySelectorAll('.entry-block'));
            var naturalHeights = entryEls.map(function (el) { return Math.max(1, el.offsetHeight); });
            var pages = _this.packEntriesIntoPages(naturalHeights, packBudget, packBudget);
            pages.forEach(function (page, pageIndex) {
                var count = page.indices.length;
                if (!count) {
                    return;
                }
                page.indices.forEach(function (entryIndex, i) {
                    race.entries[entryIndex].forcePageBreak = pageIndex > 0 && i === 0;
                });
                var naturalSum = page.indices.reduce(function (sum, idx) { return sum + naturalHeights[idx]; }, 0);
                var targetSum = formulaPageBudget(count);
                if (naturalSum >= targetSum) {
                    page.indices.forEach(function (entryIndex) {
                        race.entries[entryIndex].stretchMinHeightPx = naturalHeights[entryIndex];
                    });
                    return;
                }
                var scale = targetSum / naturalSum;
                var used = 0;
                page.indices.forEach(function (entryIndex, i) {
                    var h;
                    if (i === count - 1) {
                        h = Math.max(naturalHeights[entryIndex], targetSum - used);
                    }
                    else {
                        h = Math.max(naturalHeights[entryIndex], Math.round(naturalHeights[entryIndex] * scale));
                        used += h;
                    }
                    race.entries[entryIndex].stretchMinHeightPx = h;
                });
            });
            // One silk size for this race only — bigger for small fields, always
            // leave silkPad clear of the horizontal rules.
            var n = race.entries.length;
            var maxSilk = n <= 8 ? 72 : n <= 12 ? 60 : 52;
            var formulaSilk = Math.min(maxSilk, (20 / n) * 50);
            var minRow = Math.min.apply(null, race.entries.map(function (e) { return e.stretchMinHeightPx || 58; }));
            var silkFromRow = Math.max(40, Math.min(maxSilk, minRow - silkPad * 2));
            var silkSize = Math.min(maxSilk, Math.max(formulaSilk, silkFromRow));
            race.entries.forEach(function (entry) {
                entry.imageSize = silkSize;
            });
        });
        this.changeDetector.detectChanges();
    };
    /**
     * Contiguous pack into the fewest pages, balanced across pages
     * (avoids greedy 12+3 when ~8+7 would fill both sheets better).
     */
    FixtureRacecardsComponent.prototype.packEntriesIntoPages = function (heights, page1Usable, pageRestUsable) {
        var n = heights.length;
        if (!n) {
            return [];
        }
        var prefix = [0];
        heights.forEach(function (h, i) { return prefix.push(prefix[i] + h); });
        var rangeSum = function (from, to) { return prefix[to] - prefix[from]; };
        var pageUsableAt = function (pageIndex) { return pageIndex === 0 ? page1Usable : pageRestUsable; };
        var minPages = this.minPagesNeeded(heights, page1Usable, pageRestUsable);
        if (minPages <= 1) {
            return [{ indices: heights.map(function (_, i) { return i; }), height: rangeSum(0, n) }];
        }
        // DP: place first `i` entries into exactly `p` pages; minimize imbalance score
        // prev[i][p] = start index of the last page when placing i entries in p pages
        var INF = Number.POSITIVE_INFINITY;
        var bestMax = Array.from({ length: n + 1 }, function () { return Array(minPages + 1).fill(INF); });
        var prevSplit = Array.from({ length: n + 1 }, function () { return Array(minPages + 1).fill(-1); });
        bestMax[0][0] = 0;
        for (var p = 1; p <= minPages; p++) {
            for (var i_1 = p; i_1 <= n; i_1++) {
                for (var j = p - 1; j < i_1; j++) {
                    var pageHeight = rangeSum(j, i_1);
                    var usable = pageUsableAt(p - 1);
                    if (pageHeight > usable || bestMax[j][p - 1] === INF) {
                        continue;
                    }
                    // Minimize the worst page fill ratio so leftover stretch is even
                    var fill = pageHeight / usable;
                    var score = Math.max(bestMax[j][p - 1], fill);
                    if (score < bestMax[i_1][p]) {
                        bestMax[i_1][p] = score;
                        prevSplit[i_1][p] = j;
                    }
                }
            }
        }
        // Reconstruct page boundaries
        if (bestMax[n][minPages] === INF) {
            // Fallback — should be rare
            return this.greedyPack(heights, page1Usable, pageRestUsable);
        }
        var bounds = [n];
        var i = n;
        for (var p = minPages; p >= 1; p--) {
            var j = prevSplit[i][p];
            bounds.push(j);
            i = j;
        }
        bounds.reverse();
        var pages = [];
        for (var p = 0; p < bounds.length - 1; p++) {
            var from = bounds[p];
            var to = bounds[p + 1];
            var indices = [];
            for (var idx = from; idx < to; idx++) {
                indices.push(idx);
            }
            pages.push({ indices: indices, height: rangeSum(from, to) });
        }
        return pages;
    };
    FixtureRacecardsComponent.prototype.minPagesNeeded = function (heights, page1Usable, pageRestUsable) {
        return this.greedyPack(heights, page1Usable, pageRestUsable).length || 1;
    };
    FixtureRacecardsComponent.prototype.greedyPack = function (heights, page1Usable, pageRestUsable) {
        var pages = [];
        var current = { indices: [], height: 0 };
        var usable = page1Usable;
        heights.forEach(function (height, index) {
            if (current.indices.length && current.height + height > usable) {
                pages.push(current);
                current = { indices: [], height: 0 };
                usable = pageRestUsable;
            }
            current.indices.push(index);
            current.height += height;
        });
        if (current.indices.length) {
            pages.push(current);
        }
        return pages;
    };
    FixtureRacecardsComponent.prototype.getPrintPageUsableHeightPx = function () {
        // A4 (297mm) minus 0.5cm top+bottom (=10mm) → 287mm printable.
        // Use both a CSS-mm probe and a 96dpi fallback; take the larger so we
        // don't under-fill when the probe resolves mm too small.
        var probe = document.createElement('div');
        probe.style.cssText =
            'position:absolute;left:-99999px;top:0;visibility:hidden;height:287mm;width:10px;pointer-events:none;';
        document.body.appendChild(probe);
        var probed = probe.offsetHeight;
        document.body.removeChild(probe);
        var fallback = Math.floor(287 * 96 / 25.4); // ~1085px
        return Math.max(probed || 0, fallback);
    };
    return FixtureRacecardsComponent;
}());
export { FixtureRacecardsComponent };
